import React, { FC, useState } from 'react';
import Plus from 'images/icons/Plus.svg?react';
import { SButtonPlus, SButtons, SWrapper } from './styles';

const FloatingButton: FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [isActive, setActive] = useState(false);

    return (
        <SWrapper onMouseLeave={() => setActive(false)}>
            <SButtonPlus isActive={isActive} onClick={() => setActive(!isActive)} type="button">
                <Plus />
            </SButtonPlus>
            {isActive && <SButtons>{children}</SButtons>}
        </SWrapper>
    );
};

export default FloatingButton;
